import { AppContext } from "@/App.context";
import config from "@/config";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import {
  API_LOADING_ERROR,
  API_NO_DATA_FOUND_ERROR,
  API_NOT_FOUND_ERROR,
  ERROR_STATUS_CODES,
} from "@/lib/errors/error-constants";

export const getBarGraphAnomalies = (token) => {
  return async ({ service }) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/cost-anomaly/chartData`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      if (ERROR_STATUS_CODES.includes(owners.status)) {
        throw new Error(API_LOADING_ERROR);
      }
      if (owners.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR);
      }
      throw new Error((await owners.json()).message);
    }
    const data = await owners.json();

    if (
      (data?.azure && data?.azure.length === 0) ||
      (data?.aws && data?.aws.length === 0) ||
      (data?.gcp && data?.gcp.length === 0)
    ) {
      throw new Error(API_NO_DATA_FOUND_ERROR);
    }

    return data;
  };
};

/**

 * @param {GetStatisticsReq} req
 * @param {any[]=} deps
 */
export const useBarGraphAnomalies = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getBarGraphAnomalies", req, ...deps],
    queryFn: () => getBarGraphAnomalies(appContext.idToken)(req),
  });
  return query;
};
